import script from "./IDESideBarContentTabFileSystemTreeEntry.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDESideBarContentTabFileSystemTreeEntry.vue?vue&type=script&lang=ts&setup=true"

import "./IDESideBarContentTabFileSystemTreeEntry.vue?vue&type=style&index=0&id=cbabf67c&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbabf67c"]])

export default __exports__